<div class="app-footer">
    <div class="footer-project">
        © Titulización de Activos, SGFT, S.A
    </div>
</div>